







import { computed, defineComponent, PropType } from "@vue/composition-api";
import { CallStatus, isCallMessageDetails } from "@scrile/api-provider/dist/api/CallsProvider";
import { Message } from "@scrile/api-provider/dist/projects/scrileConnect/MessagesProvider";
import { $t } from "@/lib/i18nHelpers";

export default defineComponent({
  name: "MessagePreview",
  props: {
    message: { type: Object as PropType<Message>, required: true },
    isOpponentMessage: { type: Boolean, required: true },
  },
  setup(props) {
    const text = computed(() => {
      if (isCallMessageDetails(props.message.details)) {
        const status = props.message.details.status;
        if (status === CallStatus.ENDED) {
          return props.isOpponentMessage ? $t("Incoming call") : $t("Outgoing call");
        }
        if (props.isOpponentMessage) return $t("Missed call");
        if (status === CallStatus.CANCELLED) return $t("Canceled call");
        if (status === CallStatus.DECLINED) return $t("Declined call");
      }
      return "";
    });

    return { text };
  },
});
